import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@app/core';
import { TranslateModule } from '@ngx-translate/core';
import {
    DxButtonModule,
    DxChartModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDateRangeBoxModule,
    DxFileUploaderModule,
    DxFormModule,
    DxPieChartModule,
    DxPopupModule,
    DxProgressBarModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxTagBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxTooltipModule,
    DxValidationGroupModule,
    DxValidatorModule
} from 'devextreme-angular';
import { AgentAuthenticationModePickerComponent } from './agent-authentication-mode-picker/agent-authentication-mode-picker.component';
import { AgentTypePickerComponent } from './agent-type-picker/agent-type-picker.component';
import { AzureServiceTypePickerComponent } from './azure-service-type-picker/azure-service-type-picker.component';
import { DayPickerComponent } from './day-picker/day-picker.component';
import { EmployeePickerComponent } from './employee-picker/employee-picker.component';
import { EnvironmentLogComponent } from './environment-log-popup/environment-log-popup.component';
import { EnvironmentPickerComponent } from './environment-picker/environment-picker.component';
import { ExecutionModePickerComponent } from './execution-mode-picker/execution-mode-picker.component';
import { FileTransferAlertsComponent } from './file-transfer-alerts/file-transfer-alerts.component';
import { FileTransferApiKeysComponent } from './file-transfer-api-keys/file-transfer-api-keys.component';
import { FileTransferExecutionComponent } from './file-transfer-execution-popup/file-transfer-execution-popup.component';
import { FileTransferFormComponent } from './file-transfer-form/file-transfer-form.component';
import { FileTransferInfoPickerComponent } from './file-transfer-info-picker/file-transfer-info-picker.component';
import { FileTransferLogComponent } from './file-transfer-log-popup/file-transfer-log-popup.component';
import { FileTransferLogsComponent } from './file-transfer-logs/file-transfer-logs.component';
import { FileTransferPickerComponent } from './file-transfer-picker/file-transfer-picker.component';
import { FileTransferRenamingParametersComponent } from './file-transfer-renaming-parameters/file-transfer-renaming-parameters.component';
import { HttpVerbPickerComponent } from './http-verb-picker/http-verb-picker.component';
import { LocalAgentCheckConnectionComponent } from './local-agent-check-connection-popup/local-agent-check-connection-popup.component';
import { LocalAgentCommandComponent } from './local-agent-command-popup/local-agent-command-popup.component';
import { LocalAgentPickerComponent } from './local-agent-picker/local-agent-picker.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { PgpKeyPickerComponent } from './pgp-key-picker/pgp-key-picker.component';
import { AzureStoragePopupComponent } from './remote-platform-azure-storage-popup/remote-platform-azure-storage-popup.component';
import { FtpPopupComponent } from './remote-platform-ftp-popup/remote-platform-ftp-popup.component';
import { HttpPopupComponent } from './remote-platform-http-popup/remote-platform-http-popup.component';
import { RemotePlatformLogComponent } from './remote-platform-log-popup/remote-platform-log-popup.component';
import { RemotePlatformPickerComponent } from './remote-platform-picker/remote-platform-picker.component';
import { SftpPopupComponent } from './remote-platform-sftp-popup/remote-platform-sftp-popup.component';
import { SharePointPopupComponent } from './remote-platform-sharepoint-popup/remote-platform-sharepoint-popup.component';
import { SftpVersionPickerComponent } from './sftp-version-picker/sftp-version-picker.component';
import { SpPlatformPickerComponent } from './sp-platform-picker/sp-platform-picker.component';
import { FileTransferOnDemandExecutionsComponent } from './file-transfer-ondemand-executions/file-transfer-ondemand-executions.component';
import { FileTransferStatisticsComponent } from './file-transfer-statistics/file-transfer-statistics.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        CoreModule,
        TranslateModule,
        DxButtonModule,
        DxChartModule,
        DxPieChartModule,
        DxCheckBoxModule,
        DxDataGridModule,
        DxDateBoxModule,
        DxDateRangeBoxModule,
        DxPopupModule,
        DxSelectBoxModule,
        DxScrollViewModule,
        DxTagBoxModule,
        DxValidatorModule,
        DxTextBoxModule,
        DxTextAreaModule,
        DxProgressBarModule,
        DxFormModule,
        DxSwitchModule,
        DxValidationGroupModule,
        DxFileUploaderModule,
        DxTooltipModule,
        DxToolbarModule
    ],
    declarations: [
        AgentAuthenticationModePickerComponent,
        AgentTypePickerComponent,
        AzureServiceTypePickerComponent,
        MainLayoutComponent,
        EmployeePickerComponent,
        EnvironmentPickerComponent,
        ExecutionModePickerComponent,
        FileTransferAlertsComponent,
        FileTransferApiKeysComponent,
        FileTransferFormComponent,
        FileTransferLogsComponent,
        FileTransferOnDemandExecutionsComponent,
        FileTransferPickerComponent,
        FileTransferInfoPickerComponent,
        FileTransferRenamingParametersComponent,
        FileTransferStatisticsComponent,
        LocalAgentCommandComponent,
        LocalAgentPickerComponent,
        RemotePlatformPickerComponent,
        SpPlatformPickerComponent,
        DayPickerComponent,
        SftpVersionPickerComponent,
        HttpVerbPickerComponent,
        PgpKeyPickerComponent,
        RemotePlatformLogComponent,
        EnvironmentLogComponent,
        FileTransferLogComponent,
        LocalAgentCheckConnectionComponent,
        LocalAgentCommandComponent,
        AzureStoragePopupComponent,
        FtpPopupComponent,
        HttpPopupComponent,
        SftpPopupComponent,
        SharePointPopupComponent,
        FileTransferExecutionComponent
    ],
    exports: [
        AgentAuthenticationModePickerComponent,
        AgentTypePickerComponent,
        AzureServiceTypePickerComponent,
        EmployeePickerComponent,
        EnvironmentPickerComponent,
        ExecutionModePickerComponent,
        FileTransferAlertsComponent,
        FileTransferApiKeysComponent,
        FileTransferFormComponent,
        FileTransferInfoPickerComponent,
        FileTransferLogsComponent,
        FileTransferOnDemandExecutionsComponent,
        FileTransferPickerComponent,
        FileTransferRenamingParametersComponent,
        FileTransferStatisticsComponent,
        LocalAgentCommandComponent,
        LocalAgentPickerComponent,
        RemotePlatformPickerComponent,
        SftpVersionPickerComponent,
        SpPlatformPickerComponent,
        DayPickerComponent,
        HttpVerbPickerComponent,
        PgpKeyPickerComponent,
        RemotePlatformLogComponent,
        EnvironmentLogComponent,
        FileTransferLogComponent,
        LocalAgentCheckConnectionComponent,
        LocalAgentCommandComponent,
        AzureStoragePopupComponent,
        FtpPopupComponent,
        HttpPopupComponent,
        SftpPopupComponent,
        SharePointPopupComponent,
        FileTransferExecutionComponent
    ]
})
export class SharedModule { }
